import LayoutManager from "@/services/LayoutManager";
import BlokpaxLayout from "@/components/Layouts/Blokpax.vue";
import BobaLayout from "@/components/Layouts/BoBA.vue";

LayoutManager.register("dutch-auctions.blokpax.com.test", BlokpaxLayout);
// LayoutManager.register("dutch-auctions.boba.com.test", BobaLayout);

LayoutManager.register("auctions.blokpax.com", BlokpaxLayout);
